export default __webpack_public_path__ + "static/media/transport.79cdc767.png";